/* @flow */
import React from 'react';
import TreasurerAddBankAccountPage from 'payments/components/TreasurerAddBankAccountPage.jsx';

class TreasurerAddBankAccountRouteHandler extends React.Component {
  static contextTypes = {
    location: React.PropTypes.object.isRequired,
  };

  render() {
    return <TreasurerAddBankAccountPage token={this.context.location.query.access_token} />;
  }
}

export default TreasurerAddBankAccountRouteHandler;



// WEBPACK FOOTER //
// ./src/payments/routerHandlers/TreasurerAddBankAccountRouteHandler.jsx